import { defineFeedEntityPiniaStore } from "@bloglovin/vue-framework";

export const usePublicationEntityStore = defineFeedEntityPiniaStore("publication-entity-store", {
  state: () => ({}),
  getters: {},
  actions: {
  },
});
